import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { ApiOrganization, ApiUser } from '@/lib/api-client';
import { formatUsd } from '@/lib/utils';
import { Link } from '@tanstack/react-router';
import { AnnouncementsPanel } from '@/components/layout/AnnouncementsPanel';

export function DashboardPage({
  user,
  activeOrg,
}: {
  user: ApiUser;
  activeOrg: ApiOrganization;
}) {
  return (
    <div className="grid gap-6 lg:grid-cols-[1fr_320px]">
      <div className="space-y-6 min-w-0">
        <div>
          <h1 className="text-2xl font-semibold">Merhaba, {user.full_name ?? user.email}</h1>
          <p className="text-muted-foreground">
            Aktif organizasyon: <span className="font-medium">{activeOrg.name}</span> —{' '}
            <span className="capitalize">{activeOrg.role}</span>
            {user.platform_role === 'owner' && (
              <span className="ml-2 inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
                Platform Owner
              </span>
            )}
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <Card>
            <CardHeader>
              <CardTitle>Bakiye</CardTitle>
              <CardDescription>Hesabındaki kullanılabilir tutar</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-semibold font-mono">{formatUsd(activeOrg.credit_balance, 2)}</div>
              <div className="text-xs text-muted-foreground font-mono mt-0.5">{formatUsd(activeOrg.credit_balance, 6)}</div>
              <Button size="sm" asChild className="mt-3">
                <Link to="/packages">Bakiye Yükle</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Hızlı Başla</CardTitle>
              <CardDescription>Sonraki adımlar</CardDescription>
            </CardHeader>
            <CardContent className="space-y-2">
              <Button variant="outline" size="sm" className="w-full justify-start" asChild>
                <Link to="/sites">→ İlk siteni ekle</Link>
              </Button>
              <Button variant="outline" size="sm" className="w-full justify-start" asChild>
                <Link to="/content">→ İçerik oluştur</Link>
              </Button>
              <Button variant="outline" size="sm" className="w-full justify-start" asChild>
                <Link to="/team">→ Takıma editör davet et</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Right column: announcements */}
      <AnnouncementsPanel />
    </div>
  );
}
